export default __webpack_public_path__ + "static/media/icon-parking-filled.529cbf8e.svg";